import React, { useState } from 'react';
import toast from 'react-hot-toast';

const AdminLogin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();

    if (!email || !password) {
      toast.error('Please enter email and password');
      return;
    }

    setLoading(true);
    try {
      // Smart URL detection - works locally and in production
      const isLocal = window.location.hostname === 'localhost';
      const apiUrl = isLocal 
        ? 'http://localhost:5000/admin/auth/login'
        : '/admin/auth/login';
      
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ email, password }),
      });

      const data = await response.json();
      console.log('Login response:', data);

      if (data.success) {
        sessionStorage.setItem('admin', JSON.stringify(data.admin));
        localStorage.setItem('adminLoggedIn', 'true');
        toast.success('Admin login successful!');
        window.location.href = '/admin/dashboard';
      } else {
        toast.error(data.message || 'Login failed');
      }
    } catch (error) {
      console.error('Login error:', error);
      toast.error('Login failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-shell auth-shell-admin">
        <div className="auth-card auth-card-centered auth-card-admin">
          <div className="auth-card-header text-center">
            <div className="auth-brand-badge auth-brand-badge-centered">Coinspire Admin</div>
            <p className="auth-kicker">Admin Portal</p>
            <h2 className="auth-card-title">Secure admin login</h2>
            <p className="auth-card-subtitle">
              Sign in to manage users, trades, and platform activity.
            </p>
          </div>

          <form onSubmit={handleLogin} className="auth-form">
            <div className="auth-field">
              <label className="auth-label">Admin Email</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="auth-input"
                placeholder="admin@coinspire.com"
                disabled={loading}
              />
            </div>

            <div className="auth-field">
              <label className="auth-label">Password</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="auth-input"
                placeholder="Enter your password"
                disabled={loading}
              />
            </div>

            <button type="submit" className="auth-submit-btn" disabled={loading}>
              {loading ? 'Logging in...' : 'Admin Login'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;